import type { UnverifiedAssetStatus } from '@terra/shared-contracts-assets';

export const UNVERIFIED_ASSET_STATUS_LABEL_KEYS = {
  FAILED: 'verificationStatusFailed',
  BLOCKED: 'verificationStatusBlocked',
  REJECTED: 'verificationStatusRejected',
  PENDING: 'verificationStatusPending',
} as const satisfies Record<
  UnverifiedAssetStatus,
  `verificationStatus${string}`
>;

export const UNVERIFIED_ASSET_STATUS_FILTER_ORDER = [
  'FAILED',
  'BLOCKED',
  'REJECTED',
  'PENDING',
] as const satisfies readonly UnverifiedAssetStatus[];

export const UNVERIFIED_ASSET_STATUS_DEFAULT_FILTER_ORDER = [
  'FAILED',
  'BLOCKED',
] as const satisfies readonly UnverifiedAssetStatus[];

export const resolveUnverifiedAssetStatusFilterOrder = ({
  includeAllStatuses,
}: {
  includeAllStatuses: boolean;
}): readonly UnverifiedAssetStatus[] =>
  includeAllStatuses
    ? UNVERIFIED_ASSET_STATUS_FILTER_ORDER
    : UNVERIFIED_ASSET_STATUS_DEFAULT_FILTER_ORDER;

const isUnverifiedAssetStatus = (
  value: string,
): value is UnverifiedAssetStatus =>
  Object.hasOwn(UNVERIFIED_ASSET_STATUS_LABEL_KEYS, value);

export const parseUnverifiedAssetStatuses = (
  values: readonly string[],
): UnverifiedAssetStatus[] =>
  values.map((value) => value.trim()).filter(isUnverifiedAssetStatus);

export const UNVERIFIED_ASSET_STATUS_TOOLTIP_KEYS: Partial<
  Record<UnverifiedAssetStatus, `verificationStatus${string}Tooltip`>
> = {
  FAILED: 'verificationStatusFailedTooltip',
  BLOCKED: 'verificationStatusBlockedTooltip',
  REJECTED: 'verificationStatusRejectedTooltip',
  PENDING: 'verificationStatusPendingTooltip',
};

export const resolveUnverifiedAssetStatusLabelKey = ({
  unverifiedStatus,
}: {
  unverifiedStatus: UnverifiedAssetStatus;
}): (typeof UNVERIFIED_ASSET_STATUS_LABEL_KEYS)[UnverifiedAssetStatus] =>
  UNVERIFIED_ASSET_STATUS_LABEL_KEYS[unverifiedStatus];

export const resolveUnverifiedAssetStatusTooltipKey = ({
  unverifiedStatus,
}: {
  unverifiedStatus: UnverifiedAssetStatus;
}): (typeof UNVERIFIED_ASSET_STATUS_TOOLTIP_KEYS)[UnverifiedAssetStatus] =>
  UNVERIFIED_ASSET_STATUS_TOOLTIP_KEYS[unverifiedStatus];
